/* eslint-disable react/require-default-props */
/* eslint-disable camelcase */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/alt-text */
import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
// eslint-disable-next-line import/no-named-as-default
import PinchZoomPan from './PinchZoomPan';
import * as styles from './InnerImageZoom.css';

const cx = classNames.bind(styles);

const RegularImage = ({
    src,
    sources,
    width,
    height,
    hasSpacer,
    imgAttributes,
    isZoomed,
    isLandscape,
    fadeDuration,
    deviceType,
    updateWidth,
    imageOnLoad,
    isDoubleclickZoomed,
    isPinchinZoomed,
    enableZoomOnProductImage,
}) => {
    const createSpacer = width && height && hasSpacer;
    const ZoomContainer_ImageStyle = dt([
        'w-full',
        'h-auto',
        'block',
        'pointer-events-none',
        'visible',
        'opacity-100',
    ]);
    const displayImageStyle = dt(['w-full', 'h-full', 'absolute', 'top-0', 'left-0', 'block']);
    const imageRef = useRef();
    const regularImage = () => {
        return (
            <div style={{ paddingTop: createSpacer ? `${(height / width) * 100}%` : null }}>
                {sources && sources.length > 0 ? (
                    <picture>
                        {
                            /* istanbul ignore if */ sources.map((source, i) => {
                                return (
                                    <Fragment key={i}>
                                        {source.srcSet && <source {...source} />}
                                    </Fragment>
                                );
                            })
                        }

                        <img
                            {...imgAttributes}
                            className={`${dt([
                                ZoomContainer_ImageStyle,
                                isZoomed && 'invisible',
                                isZoomed && 'opacity-0',
                                createSpacer && displayImageStyle,
                            ])}
                                ${cx('ZoomContainer_Image', imgAttributes.className || '')}`}
                            style={{
                                transition: `opacity 0ms linear ${
                                    isZoomed ? fadeDuration : 0
                                }ms, visibility 0ms linear ${isZoomed ? fadeDuration : 0}ms`,
                            }}
                            src={src}
                            ref={imageRef}
                            width={width}
                            height={height}
                            onLoad={imageOnLoad}
                        />
                    </picture>
                ) : (
                    <img
                        {...imgAttributes}
                        className={`${cx(
                            'ZoomContainer_Image',
                            (imgAttributes && imgAttributes.className) || ''
                        )} ${dt([
                            ZoomContainer_ImageStyle,
                            isZoomed && 'invisible',
                            isZoomed && 'opacity-0',
                            createSpacer && displayImageStyle,
                        ])}`}
                        style={{
                            transition: `opacity 0ms linear ${
                                isZoomed ? fadeDuration : 0
                            }ms, visibility 0ms linear ${isZoomed ? fadeDuration : 0}ms`,
                        }}
                        src={src}
                        ref={imageRef}
                        width={width}
                        height={height}
                        onLoad={imageOnLoad}
                    />
                )}
            </div>
        );
    };
    return (
        <div>
            {!deviceType?.isDesktop && !isLandscape ? (
                <PinchZoomPan
                    isZoomed={isZoomed}
                    maxScale={2}
                    updateWidth={updateWidth}
                    isDoubleclickZoomed={isDoubleclickZoomed}
                    isPinchinZoomed={isPinchinZoomed}
                    enableZoomOnProductImage={enableZoomOnProductImage}
                >
                    {regularImage()}
                </PinchZoomPan>
            ) : (
                regularImage()
            )}
        </div>
    );
};

RegularImage.propTypes = {
    src: PropTypes.string.isRequired,
    sources: PropTypes.array,
    width: PropTypes.number,
    height: PropTypes.number,
    hasSpacer: PropTypes.bool,
    imgAttributes: PropTypes.object,
    fadeDuration: PropTypes.number,
    isZoomed: PropTypes.bool,
    isLandscape: PropTypes.bool,
    zoomOut: PropTypes.func,
    deviceType: PropTypes.object,
    updateWidth: PropTypes.func,
    imageOnLoad: PropTypes.func,
    enableZoomOnProductImage: PropTypes.bool,
};

export default RegularImage;
